import React from 'react';

import styles from '../app/App.scss';
import { t } from '../../services/i18nService';

const SkipLink = () => {
    const skipLinkClickHandler = (evt) => {
        document.getElementById('footer-nav-wrapper').focus();
        evt.preventDefault();
        return false;
    };

    return (
        <button
            className={styles.skipToNavigationLink}
            onClick={skipLinkClickHandler}
            aria-label={t('main.skipLinkAriaLabelText')}
        >
            {t('main.skipLink')}
        </button>
    );
};

export default SkipLink;
